export default __webpack_public_path__ + "static/media/eps3.d897f315.png";